// Browser-/OS-Locale (z.B. "de-DE", "pt-BR", "en-US") auf einen
// i18n-Resource-Key dieser App mappen.
// Resource-Keys siehe src/i18n.jsx: en, du, es, fr, pt, pt-BR.
export const detectBrowserLanguage = (locale) => {
  const raw = (
    locale ||
    (typeof navigator !== 'undefined' &&
      (navigator.language || navigator.userLanguage)) ||
    'en'
  ).toLowerCase()

  if (raw === 'pt-br' || raw.startsWith('pt-br')) return 'pt-BR'
  if (raw.startsWith('de')) return 'du'
  if (raw.startsWith('es')) return 'es'
  if (raw.startsWith('pt')) return 'pt'
  if (raw.startsWith('fr')) return 'fr'
  if (raw.startsWith('en')) return 'en'
  return 'en'
}

export default detectBrowserLanguage
